<script>
import Inputmask from "inputmask";

export default {
    inheritAttrs: false,
    props: {
        placeholder: {
            type: String,
            default: "",
        },
        mask: {
            type: String,
            default: "",
        },
        pattern: {
            validator: (v) => typeof v === 'string' || v === null,
            default: null,
        },
    },
    data() {
        return {
            text: "",
            isFocused: false,
        };
    },
    computed: {
        rootClass() {
            if (this.isFocused || (this.text && this.text.length > 0)) {
                return ["is-caption-lifted"];
            } else {
                return [];
            }
        },
    },
    mounted() {
        const vm = this;
        if (this.mask) {
            vm.imask = new Inputmask({
                mask: this.mask,
                placeholder: "●",
                showMaskOnHover: false,
                showMaskOnFocus: true,
                onBeforePaste: function (pastedValue) {
                    var numbers = vm.formatValue(pastedValue);

                    vm.text = numbers;
                    return numbers;
                },
            }).mask(this.$refs.input);
        }

        window.addEventListener("clearform", () => {
            this.clear();
        });
    },
    methods: {
        clear() {
            this.text = "";
            if (this.imask) {
                this.imask.value = "";
            }
        },
        onInput(event) {
            if (event.isTrusted && event.inputType == "insertText" && event.data) {
                const value = this.formatValue(event.data);
                this.text = value;
                if (this.imask) {
                    this.imask.value = value;
                }
            }
        },
        formatValue(value) {
            var numbers = value.replace(/\D/g, "");

            if (numbers && numbers.length > 0) {
                numbers = "+" + numbers;
            }

            if (numbers && numbers.length > 2) {
                numbers = numbers.splice(2, 0, " (");
            }

            if (numbers && numbers.length > 7) {
                numbers = numbers.splice(7, 0, ") ");
            }

            if (numbers && numbers.length > 12) {
                numbers = numbers.splice(12, 0, "-");
            }

            return numbers;
        },
    }
};
</script>

<template>
    <div class="animated-input" :class="rootClass">
        <div class="placeholder">{{ placeholder }}</div>
        <div class="input-wrap">
            <input
                v-if="!mask || mask.length < 1"
                ref="input"
                v-bind="$attrs"
                v-model="text"
                :pattern="pattern"
                @focus="$data.isFocused = true"
                @blur="$data.isFocused = false"
            />
            <input
                v-if="mask && mask.length > 0"
                ref="input"
                v-bind="$attrs"
                v-model="text"
                :pattern="pattern"
                @focus="$data.isFocused = true"
                @blur="$data.isFocused = false"
                @input="onInput"
            />
        </div>
    </div>
</template>
